module.exports = __webpack_public_path__ + "assets/opensans-bold.svg?93349923b5274a36ac93cb3168d09123";